module.exports = __webpack_public_path__ + "assets/img/per-fffa2503.png";